import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useUserInfo } from '../../Authentication/hooks'
import NavigationComponent from '../navigationComponent'
import {
  customPostRequest,
  fetchUserSubscription,
  validateGeneralCategoryData,
  createNavigationHandlers,
  handleAsyncError
} from './utils/categoryUtils'
import '../../../assets/stylesheets/kategories.css'

const BirthdayCategory = () => {
  const [name, setName] = useState('')
  const [date, setDate] = useState('')
  const [birthdays, setBirthdays] = useState([])
  const { userId } = useUserInfo()
  const [message, setMessage] = useState('')
  const navigate = useNavigate()
  const [categoryCreated, setCategoryCreated] = useState(false)
  const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
  const [showUpgradeLink, setShowUpgradeLink] = useState(false)

  const { handleHomeClick, handleUploadClick, handleSubscribeClick } =
    createNavigationHandlers(navigate)

  const handleCreate = async () => {
    if (!userId) {
      setMessage('User not authenticated')
      setShowUpgradeLink(false)
      return
    }

    if (!name || !date) {
      setMessage('Please enter both birthday name and date')
      setShowUpgradeLink(false)
      return
    }

    try {
      const subscriptionData = await fetchUserSubscription(
        userId,
        API_GATEWAY_URL
      )
      if (!subscriptionData) {
        setMessage('Failed to fetch subscription data')
        setShowUpgradeLink(true)
        return
      }

      const { categoryCount, categoryLimit } = subscriptionData

      console.log('Subscription Data:', categoryCount + 1, categoryLimit)
      if (categoryCount >= categoryLimit) {
        setMessage('You have reached your category limit.')
        setShowUpgradeLink(true)
        return
      }
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'fetching category count')
      setMessage(`Failed to fetch category count: ${errorMessage}`)
      setShowUpgradeLink(true)
      return
    }

    const categoryData = {
      userId: userId,
      name: name,
      type: 'event',
      subType: 'birthday',
      calendarAttrs: {
        fromDate: date + 'T00:00:00Z',
        toDate: date + 'T23:59:59Z',
        annual: true
      }
    }

    if (!validateGeneralCategoryData(categoryData, setMessage)) {
      return
    }

    try {
      const apiURL = `${process.env.REACT_APP_API_GATEWAY_URL}/k1/users/${userId}/categories`
      const responseData = await customPostRequest(apiURL, categoryData)

      if (responseData.error) {
        throw new Error(responseData.error)
      }

      setBirthdays(prev => [...prev, { name, date }])
      setName('')
      setDate('')
      setMessage('Category created successfully!')
      setCategoryCreated(true)
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'creating category')
      setMessage(`Failed to create category: ${errorMessage}`)
    }
  }

  return (
    <div className="birthday-category">
      <NavigationComponent handleHomeClick={handleHomeClick} />
      <h2 className="category-header">Birthday</h2>
      {message && <p className="message">{message}</p>}
      {showUpgradeLink && (
        <p>
          Please{' '}
          <span className="link-like" onClick={handleSubscribeClick}>
            upgrade
          </span>{' '}
          your plan.
        </p>
      )}
      {message === 'Category created successfully!' && (
        <p>
          <Link to="/gallery">Click here</Link> to return to the main gallery.
        </p>
      )}
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={e => setName(e.target.value)}
        className="input-field"
      />
      <input
        type="date"
        value={date}
        onChange={e => setDate(e.target.value)}
        className="input-field"
      />
      <div className="button-group">
        <button onClick={handleCreate} className="create-button">
          Create
        </button>
      </div>
      {categoryCreated && (
        <div className="list_and_upload">
          <ul>
            {birthdays.map((birthday, index) => (
              <li
                className="added-list"
                key={`${birthday.name}-${birthday.date}`}
              >
                {birthday.name} - {birthday.date}
              </li>
            ))}
          </ul>
          <button className="upload-button-list" onClick={handleUploadClick}>
            Upload Photos
          </button>
        </div>
      )}
    </div>
  )
}

export default BirthdayCategory
